import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import React, { useEffect, useState } from 'react';
import { Button, Navbar, NavDropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Icon from '../../assets/images/icon.png';
import Logo from '../../assets/images/logo.jpg';
import './style.scss';

const Header = () => {
  const isAuthenticated = useIsAuthenticated();
  const { accounts, instance } = useMsal();
  const [name, setName] = useState(null);

  useEffect(() => {
    if (accounts.length > 0) {
      setName(accounts[0].name);
    }
  }, [accounts]);

  const handleSignOut = () => {
    instance.logout();
  };

  const handleSignIn = () => {
    instance.loginRedirect();
  };
  return (
    <Navbar className="vlu-header" expand="lg" variant="dark" bg="dark">
      <Navbar.Brand className="vlu-header-brand">
        <Link to="/">
          <img
            src={Logo}
            height="60"
            className="d-inline-block align-top"
            alt="VLU"
          />
        </Link>
      </Navbar.Brand>
      <Navbar.Collapse className="justify-content-end">
        {isAuthenticated
          ? (
            <NavDropdown title={name} className="profile-name" id="profile-dropdown">
              <NavDropdown.Item as={Link} to="/lich-su">Xem lịch sử</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item as={Link} to="/portfolio">Portfolio</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item as={Button} onClick={handleSignOut}>Đăng xuất</NavDropdown.Item>
            </NavDropdown>
          )
          : (
            <Button variant="primary" onClick={handleSignIn}>
              {'Đăng nhập '}
              <img src={Icon} alt="Trung tam phat trien nang luc" width="20" />
            </Button>
          )}
      </Navbar.Collapse>
    </Navbar>
  );
};

export default Header;
